export const messagesAnalytics = {
	pageTitle: "Informe de mensajes",
	pageSubtitle:
		"Acompañe el volumen, costo y orígenes de los envíos de SMS en la organización.",
	filters: {
		dateRange: "Período",
		origin: "Origen",
		place: "Local",
		event: "Evento",
		allOrigins: "Filtrar por origen",
		allPlaces: "Filtrar por Local",
		placesLabel: "Local",
		originsLabel: "Origen",
		allEvents: "Filtrar por Evento",
	},
	cards: {
		totalSent: "Total Enviados",
		activePlaces: "Locales Activos",
		eventsWithMessages: "Eventos con Envío",
		distinctOrigins: "Orígenes Distintos",
		vsPreviousPeriod: "vs período anterior",
		ofRegistered: "de {{total}} registrados",
		distinctOriginsCount: "{{count}} orígenes distintos",
		deliveryStatus: "Estado de Entrega",
		delivered: "Entregados",
		failed: "Fallidos",
		successRate: "Tasa de Éxito",
	},
	charts: {
		byOrigin: "SMS por origen",
		byPlace: "SMS por local",
		dailyVolume: "Volumen diario de envíos",
		showAll: "Ver todos ({{count}})",
		showLess: "Ver menos",
		deliveryStatus: "Estado de entrega",
		successRate: "Tasa de éxito",
	},
	ranking: {
		title: "Mayores envíos en el período",
	},
	origins: {
		npsForm: "Encuesta de satisfacción (NPS)",
		giftback: "Giftback",
		campaignMessage: "Envío de Mensajes",
		givePromotion: "Promoción",
		digitalCashlessRechargeLowBalanceSms: "SMS de recarga (saldo bajo cashless digital)",
		withdrawRequest: "Confirmación de solicitud de retiro",
		pdvPaymentReceipt: "Comprobante de pago PDV",
		loyaltyProgramCreated: "Programa de Fidelidad",
		coalaIntegration: "Delivery",
		kitchen: "Grab&Go (Aplicación B2C)",
	},
	originCategories: {
		npsForm: "NPS",
		giftback: "Cashback",
		campaignMessage: "Campaña",
		givePromotion: "Promoción",
		digitalCashlessRechargeLowBalanceSms: "Recarga",
		withdrawRequest: "Financiero",
		pdvPaymentReceipt: "PDV",
		loyaltyProgramCreated: "Fidelidad",
		coalaIntegration: "Integración",
		kitchen: "Integración",
	},
	tabs: {
		charts: "Visão Geral",
		list: "Listado",
	},
	table: {
		date: "Fecha",
		place: "Local",
		event: "Evento",
		origin: "Origen",
		smsCount: "SMS Enviados",
		deliveredCount: "Entregados",
		failedCount: "Fallidos",
		successRate: "Tasa de Éxito",
		total: "Total",
		resultsPerPage: "Resultados por página",
	},
	noData: "Sin datos para el período seleccionado",
};
